import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, ListItemButton, ListItemText, Box, Avatar, Typography } from '@mui/material';

import axiosInstance from '../../api';
import SERVER_API_URL from '../../config';
import { ethDate } from '../../utils/ethDate';

export default function UpdaterList({ openUpdater, updaterList, handleCloseMenu }) {
  const [updatersAvatar, setUpdatersAvatar] = useState({});

  const getAvatarById = async (id) => {
    try {
      const response = await axiosInstance.get(`${SERVER_API_URL}/avatar/getAvatarById/${id}`, {
        responseType: 'blob',
      });
      if (response.status === 200) {
        return URL.createObjectURL(response.data);
      }

      throw new Error('Failed to fetch avatar');
    } catch (e) {
      console.error("");
      throw e;
    }
  };

  useEffect(() => {
    const getUpdatersAvatar = (updaterList) => {
      if (Array.isArray(updaterList)) {
        updaterList.forEach((updater) => {
          if (!updatersAvatar[updater.id]) {
            getAvatarById(updater.id)
              .then((url) => {
                setUpdatersAvatar((prevUrls) => ({
                  ...prevUrls,
                  [updater.id]: url,
                }));
              })
              .catch((error) => {
                console.error('Error fetching avatar:', error);
              });
          }
        });
      }
    };
    getUpdatersAvatar(updaterList);
  }, [updaterList, updatersAvatar]);

  return (
    <Popover
      open={Boolean(openUpdater)}
      anchorEl={openUpdater}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      {updaterList &&
        updaterList.map((updater) => {
          const avatar = updatersAvatar[updater.id];
          return (
            <Box key={updater.id} sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mb: 1 }}>
              <Avatar src={avatar} alt={`${updater.firstName} ${updater.lastName}'s avatar`} />
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                  {updater.firstName} {updater.lastName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {ethDate(updater.createdAt)}
                </Typography>
              </Box>
            </Box>
          );
        })}
      {!updaterList && (
        <ListItemButton
          sx={{
            py: 1.5,
            px: 2.5,
            mt: '1px',
          }}
        >
          <ListItemText primary="አርታዒ የለውም።" />
        </ListItemButton>
      )}
    </Popover>
  );
}

UpdaterList.propTypes = {
  openUpdater: PropTypes.array.isRequired,
  updaterList: PropTypes.array.isRequired,
  handleCloseMenu: PropTypes.array.isRequired,
};
